/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormPreview from './FormPreview.vue';
import LandingPagePreview from './LandingPagePreview.vue';

const __vue_script__ = {
    name: 'DesignPreview',

    components: { FormPreview, LandingPagePreview },

    props: {
        buttonBackgroundColor: {
            type: String,
            default: '#3687FA',
        },

        buttonForegroundColor: {
            type: String,
            default: '#FFFFFF',
        },

        hideCalendar: {
            type: Boolean,
            default: false,
        },

        hideDateInfo: {
            type: Boolean,
            default: false,
        },

        banner: {
            type: Array,
            default: () => [],
        },

        hideFooter: {
            type: Boolean,
            default: true,
        },

        footerText: {
            type: String,
            default: '© YEAR - Name of the company',
        },

        event: {
            type: Object,
            required: true
        },

        settings: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            preview: 'landing-page'
        };
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"design-preview"},[_c('div',{staticClass:"buttons-toggler"},[_c('button',{staticClass:"btn",class:{'btn-primary-alt': _vm.preview === 'landing-page'},attrs:{"type":"button"},on:{"click":function($event){_vm.preview = 'landing-page'}}},[_vm._v(_vm._s(_vm.$t('registration.configuration.design_section.preview.landing_page')))]),_c('button',{staticClass:"btn",class:{'btn-primary-alt': _vm.preview === 'form'},attrs:{"type":"button"},on:{"click":function($event){_vm.preview = 'form'}}},[_vm._v(_vm._s(_vm.$t('registration.configuration.design_section.preview.form')))])]),(_vm.preview === 'landing-page')?_c('landing-page-preview',{attrs:{"button-background-color":_vm.buttonBackgroundColor,"button-foreground-color":_vm.buttonForegroundColor,"hide-calendar":_vm.hideCalendar,"hide-date-info":_vm.hideDateInfo,"banner":_vm.banner,"hide-footer":_vm.hideFooter,"footer-text":_vm.footerText,"event":_vm.event,"settings":_vm.settings}}):_vm._e(),(_vm.preview === 'form')?_c('form-preview',{attrs:{"button-background-color":_vm.buttonBackgroundColor,"button-foreground-color":_vm.buttonForegroundColor,"hide-calendar":_vm.hideCalendar,"hide-date-info":_vm.hideDateInfo,"banner":_vm.banner,"event":_vm.event}}):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DesignPreview.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__